import React from 'react'

export class ProjectPreview extends React.Component {
  render() {
    return <div className="generic-teaser-small is-preview">
             <div className='animated-background'>
               <div className='background-masker mask-picture'></div>
               <div className='background-masker mask-left-side'></div>
               <div className='background-masker mask-right-side'></div>
               <div className='background-masker mask-carrier'></div>
               <div className='background-masker mask-bottom'></div>
               <div className='background-masker mask-headline-1'></div>
               <div className='background-masker mask-headline-2'></div>
               <div className='background-masker mask-headline-3'></div>
               <div className='background-masker mask-progress'></div>
             </div>
           </div>
  }
}
